import { useCallback } from 'react';
import Request, { METHOD } from '../utils/Request';
import useRequestCallback from './useRequestCallback';

export function useDownloadContentFileFromS3PreSignedUrlCallback() {
  const {
    callback,
    loading
  } = useRequestCallback(
    useCallback(async (ignore, {
      url,
      onDownloadProgress = () => {
        return false;
      }
    }) => {
      const request = new Request();
      return request.exec({
        method: METHOD.GET,
        path: url,
        config: {
          omitTokenHeader: true,
          omitBaseHeaders: true,
          omitResponseCode: true,
          useCustomDomain: true,
          onDownloadProgress: (progressEvent) => {
            onDownloadProgress(progressEvent, request);
          }
        }
      });
    }, [])
  );
  return {
    callback,
    loading
  };
}

export default useDownloadContentFileFromS3PreSignedUrlCallback;
